export const getDefaultAssessmentsQueryParams = (patientId: string, user: any, configurations: any): string => {
  const { organization, userName } = user?.getCurrentUser?.() ?? {};
  const { tenantInfoName, nodeEnv } = configurations;
  if (!patientId || !user) return '';
  return `&patientUUID=${patientId}&userName=${userName}&organizationUUID=${organization}&appUUID=${
    tenantInfoName
  }${nodeEnv ? `-${nodeEnv}` : ''}`;
};
